import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checked\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M2.5 0h7A2.5 2.5 0 0 1 12 2.5v7A2.5 2.5 0 0 1 9.5 12h-7A2.5 2.5 0 0 1 0 9.5v-7A2.5 2.5 0 0 1 2.5 0z\" fill=\"#D91D22\" />\n        <path d=\"M10.503 2.58v1.061l-5.93 5.787-.004-.004-.014.015-3.028-3.052.517-.544L4.56 8.38z\" fill=\"#FFF\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol